// Guard to avoid redeclaration when bundled
if (typeof window === 'undefined' || !window.Slideout) {
  class Slideout {

      constructor(id) {

        this.id = id;
        this.element = $('#' + id);
        this.state = 0;
        this.event = new EventEmitter();

        this.element.find('.close').on('click', (e) => {
          e.preventDefault();
          this.hide();

        });

        window.addEventListener('keyup', (e) => {
          if(e.key == 'Escape' && this.state) {
            this.hide();
          }
        });

      }

      show() {
        this.state = 1;
        this.element.removeClass('pointer-events-none');
        this.element.find('div.backdrop').removeClass('opacity-0').addClass('opacity-100');
        this.element.find('div.modal-content').removeClass('translate-x-full').addClass('translate-x-0');
        this.event.next('show', true);
      }

      hide() {
        this.state = 0;
        this.element.addClass('pointer-events-none');
        this.element.find('div.backdrop').addClass('opacity-0').removeClass('opacity-100');
        this.element.find('div.modal-content').addClass('translate-x-full').removeClass('translate-x-0');
        this.event.next('hide', true);
      }

    }

  if (typeof window !== 'undefined') {
    window.Slideout = Slideout;
  } else {
    globalThis.Slideout = Slideout;
  }
}